module.exports = __webpack_public_path__ + "static/doctor-03-76ad978f6398f525ba9291f0ec94ddf2.png";